// Pop-up: change history (audit log) for one tip.
// Part of the Review page (components/Review.jsx). Split out 2026-10-14.
import { fmtDate, fmtTime } from './helpers.js';

export default function HistoryModal({ historyBusy, historyEntries, historyRow, refresh, setHistoryRow }) {
  return (
    <>
      {historyRow && (
        <div className="modal-backdrop" onClick={() => setHistoryRow(null)}>
          <div className="modal-card" onClick={e => e.stopPropagation()} style={{ minWidth: 640, maxWidth: 880, maxHeight: '85vh', overflowY: 'auto' }}>
            <h3 style={{ marginTop: 0 }}>Audit history — {historyRow.licensePlate} · {fmtDate(historyRow.date)} {fmtTime(historyRow.arrivalTime)}</h3>
            <div className="small" style={{ color: '#666', marginBottom: '0.5rem' }}>row id <code>{historyRow._id}</code></div>
            {historyBusy && <div>Loading…</div>}
            {!historyBusy && historyEntries && historyEntries.length === 0 && (
              <div className="card" style={{ padding: '1rem', textAlign: 'center', color: '#888' }}>No edits recorded for this row.</div>
            )}
            {!historyBusy && historyEntries && historyEntries.length > 0 && (
              <table className="fs-table tidy" style={{ fontSize: '0.9em' }}>
                <thead><tr><th>When</th><th>Who</th><th>Source</th><th>Reason</th><th>Changes</th></tr></thead>
                <tbody>
                  {historyEntries.map(a => (
                    <tr key={a.id}>
                      <td>{String(a.changed_at).slice(0,19).replace('T',' ')}</td>
                      <td>{a.changed_by || '—'}</td>
                      <td>{a.source}</td>
                      <td className="small">{a.reason || '—'}</td>
                      <td>
                        {a.changes && Object.entries(a.changes).filter(([f]) => f !== '_batchId').map(([f, v]) => (
                          <div key={f} className="small">
                            <strong>{f}:</strong> <span style={{ color: '#991b1b' }}>{String(v.from == null ? '—' : v.from)}</span>
                            {' → '}
                            <span style={{ color: '#166534' }}>{String(v.to == null ? '—' : v.to)}</span>
                          </div>
                        ))}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            <div style={{ marginTop: '1rem', textAlign: 'right' }}>
              <button className="refresh-btn" onClick={() => setHistoryRow(null)} style={{ background: '#888' }}>Close</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
